<template>
  <div class="informations-container">
    <Generalites />
    <ContexteGeopolitique />
    <SituationPolitique />
    <RisquesLocaux />
    <CartographieRisques />
    <SanitaireSante />
    <Recommandations />
  </div>
</template>

<script>
import Generalites from "./Generalites";
import ContexteGeopolitique from "./ContexteGeopolitique";
import SituationPolitique from "./SituationPolitique";
import RisquesLocaux from "./RisquesLocaux";
import CartographieRisques from "./CartographieRisques";
import SanitaireSante from "./SanitaireSante";
import Recommandations from "./Recommandations";

export default {
    name: "Informations",
    components: {
        Generalites,
        ContexteGeopolitique,
        SituationPolitique,
        RisquesLocaux,
        CartographieRisques,
        SanitaireSante,
        Recommandations
    }
}
</script>

<style scoped>
.informations-container {
  margin-top: 10px;
  padding: 5px;
}
</style>
